var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamepadDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107890809,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 39106,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 85.333333v234.666667l128 128 128-128V85.333333H384M85.333333 384v256h234.666667l128-128-128-128H85.333333m618.666667 0l-128 128 128 128H938.666667V384h-234.666667M512 576l-128 128V938.666667h256v-234.666667l-128-128M469.333333 768h85.333334v85.333333h-85.333334v-85.333333z",
    "p-id": 39107,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadDown);
export default __webpack_public_path__ + "static/media/gamepad-down.aff9be0efc625d7996383f498f8d6b35.svg";
export { ForwardRef as ReactComponent };